// SAN → figurine notation for display ("Nf3" → "♞f3").

const FIGURINES = { K: '♚', Q: '♛', R: '♜', B: '♝', N: '♞' }

export function figurine(san) {
  return san.replace(/^[KQRBN]/, (c) => FIGURINES[c]).replace(/=([QRBN])/, (_, c) => `=${FIGURINES[c]}`)
}

export function figurineLabel(move) {
  const number = move.color === 'w' ? `${move.moveNumber}.` : `${move.moveNumber}…`
  return `${number} ${figurine(move.san)}`
}
